import React from 'react';
import useBrandChefsContext from 'contexts/brand-chefs.context';
import { Input } from '@cokitchen/cokitchen-components';
import { DefaultItemToEdit } from 'contexts/brand-chefs.context/provider';
import MealSelect from './meal-dropdown';
import SelectDropdown from 'components/base/select-dropdown';
import MixSelect from 'pages/main-store/pricing/configuration/add-configuration/mix-dropdown';

const RequestConversionListDetails = () => {
  const { itemToEdit, setItemToEdit } = useBrandChefsContext();

  const handleChange = (e: { name: string; value: string; rest?: any }, index: number) => {
    const { name, value, rest } = e;
    setItemToEdit(
      itemToEdit.map((itm, i) =>
        i === index
          ? {
              ...itm,
              [name]: value,
              ...(name === 'ingredient_id'
                ? {
                    ingredient_name: rest?.ingredient?.name,
                    items: rest?.items,
                    id: rest?.id,
                    item_type: rest?.type ?? 'meal'
                  }
                : {})
            }
          : itm
      )
    );
  };

  const removeItem = (index: number) => {
    setItemToEdit(itemToEdit.filter((item, i) => index !== i));
  };

  const addVendor = () => {
    setItemToEdit([...itemToEdit, { ...DefaultItemToEdit }]);
  };

  return (
    <div>
      <h3 className='text-xl font-semibold'>Provide portion required</h3>
      {itemToEdit?.map(({ ingredient_name, item_type, ...item }, index) => (
        <div key={index} className='w-full'>
          <div className='flex justify-justify-between items-end gap-6  mt-8'>
            <div className='min-w-[150px]'>
              <SelectDropdown
                options={[
                  { id: 'meal', name: 'Meal' },
                  { id: 'mix', name: 'Mix' }
                ]}
                value={item_type === 'meal' ? 'meal' : 'mix'}
                placeholder='Portion Type'
                setValue={(val: any) => {
                  setItemToEdit(
                    itemToEdit.map((itm, i) =>
                      i === index
                        ? {
                            ...itm,
                            item_type: val.id,
                            ingredient_id: '',
                            ingredient_name: '',
                            items: []
                          }
                        : itm
                    )
                  );
                }}
                label='Select type'
                hasSearch={false}
              />
            </div>
            <div className='min-w-[200px]'>
              {item_type === 'meal' ? (
                <MealSelect {...{ handleChange, ingredient_name, index }} />
              ) : (
                <MixSelect
                  {...{
                    handleChange,
                    ingredient_name: ingredient_name ?? name ?? '',
                    index
                  }}
                />
              )}
            </div>

            <Input
              design='bordered'
              name='request_portion'
              label='Portion'
              value={item?.request_portion}
              type='number'
              onChange={(e) =>
                handleChange({ name: 'request_portion', value: e.target.value }, index)
              }
              placeholder='Portion'
            />
          </div>
          <div className='flex justify-end'>
            <button
              onClick={() => removeItem(index)}
              className='text-[#E60A2B] mt-2 font-medium text-sm '>
              - Remove Item
            </button>
          </div>
        </div>
      ))}
      <button onClick={addVendor} className='text-[#0080E5] mt-2 font-medium text-sm'>
        + Add excel meal
      </button>
    </div>
  );
};

export default RequestConversionListDetails;
